import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);


//////////////////
// WEBPACK FOOTER
// ./plugins/mask.js
// module id = ./plugins/mask.js
// module chunks = 152